import { cBigNumber } from "./BigNumber";
import { getHumanDate, getOptionInfo } from "../utils/helpers";
import { tHistoryRecordingNames, iHistoryRecording, iHistoryResponseRecordings } from "../interfaces/interfaces";


export class cHistoryRecording implements iHistoryRecording {
	blockNumber: number = NaN;
	logIdx: number = NaN;
	id: number = NaN;
	name: tHistoryRecordingNames = '';
	blockHash: string = '';
	time: number = NaN;   // ts
	txHash: string = '';
	data: string = '';

	humanTime: string= 'invalid date'; // DD mmm YY, hh:mm
	action: string = '';
	details: string[] = [];


	constructor(historyResponseRecording: iHistoryResponseRecordings){
		this.blockNumber = historyResponseRecording.blockNumber;
		this.logIdx = historyResponseRecording.logIdx;
		this.id = historyResponseRecording.id;
		this.name = historyResponseRecording.name;
		this.blockHash = historyResponseRecording.blockHash;
		this.time = historyResponseRecording.time;
		this.txHash = historyResponseRecording.txHash;
		this.data = historyResponseRecording.data;

		// human time
		this.humanTime = getHumanDate(historyResponseRecording.time, 'DD mmm YY, hh:mm');

		// action & details
		const cuttedData: string[] = historyResponseRecording.data.split(',');

		switch (historyResponseRecording.name) {
			case 'TakeBuyOrder':
				this.details = [
					getOptionInfo(+cuttedData[2]) || 'unknown option',
					`Amount: ${new cBigNumber(cuttedData[4], {currentDecimals: 18}).valueStr},
					Price: ${new cBigNumber(cuttedData[5], {currentDecimals: 18}).valueStr}`
				];
				this.action = 'Take Buy Order';
				break;

			case 'TakeSellOrder':
				this.details = [
					getOptionInfo(+cuttedData[2]) || 'unknown option',
					`Amount: ${new cBigNumber(cuttedData[4], {currentDecimals: 18}).valueStr},
					Price: ${new cBigNumber(cuttedData[5], {currentDecimals: 18}).valueStr}`
				];
				this.action = 'Take Sell Order';
				break;

			case 'CreateOption':
				this.details = [
					getOptionInfo(+cuttedData[1]) || 'unknown option',
					`Amount: ${new cBigNumber(cuttedData[2], {currentDecimals: 18}).valueStr}`
				];
				this.action = 'Create Option';
				break;

			case 'MakeSellOrder':
				this.details = [
					getOptionInfo(+cuttedData[1]) || 'unknown option',
					`Amount: ${new cBigNumber(cuttedData[3], {currentDecimals: 18}).valueStr},
					Ref price: ${new cBigNumber(cuttedData[4], {currentDecimals: 18}).valueStr},
					Delta: ${new cBigNumber(cuttedData[5], {currentDecimals: 18}).valueStr},
					Order price: ${new cBigNumber(cuttedData[6], {currentDecimals: 18}).valueStr},
					Min price: ${new cBigNumber(cuttedData[7], {currentDecimals: 18}).valueStr}`
				];
				this.action = 'Make Sell Order';
				break;

			case 'FinalizeOptionExercise':
				this.details = [
					getOptionInfo(+cuttedData[1]) || 'unknown option',
					`Amount: ${new cBigNumber(cuttedData[2], {currentDecimals: 18}).valueStr}`
				];
				this.action = 'Finalize Option Exercise';
				break;

			case 'WithdrawOption':
				this.details = [
					getOptionInfo(+cuttedData[1]) || 'unknown option',
					`Call amount: ${new cBigNumber(cuttedData[2], {currentDecimals: 18}).valueStr},
					Exec amount: ${new cBigNumber(cuttedData[3], {currentDecimals: 18}).valueStr}`
				];
				this.action = 'Withdraw Option';
				break;

			case 'RequestOptionExercise':
				if (+new cBigNumber(cuttedData[2], {currentDecimals: 18}).valueStr === 0){
					this.details = [
						getOptionInfo(+cuttedData[1]) || 'unknown option'
					];
					this.action = 'Cancel Option Exercise'
				} else {
					this.details = [
						getOptionInfo(+cuttedData[1]) || 'unknown option',
						`Amount: ${new cBigNumber(cuttedData[2], {currentDecimals: 18}).valueStr}`
					];
					this.action = 'Request Option Exercise';
				}
				break;

			case 'AcceptTsReq':
				this.details = [
					getOptionInfo(+cuttedData[0]) || 'unknown option'
				];
				this.action = 'Accept TS Request';
				break;

			case 'MakeBuyOrder':
				this.details = [
					getOptionInfo(+cuttedData[1]) || 'unknown option',
					`Amount: ${new cBigNumber(cuttedData[3], {currentDecimals: 18}).valueStr},
					Ref price: ${new cBigNumber(cuttedData[4], {currentDecimals: 18}).valueStr},
					Delta: ${new cBigNumber(cuttedData[5], {currentDecimals: 18}).valueStr},
					Order price: ${new cBigNumber(cuttedData[6], {currentDecimals: 18}).valueStr},
					Min price: ${new cBigNumber(cuttedData[7], {currentDecimals: 18}).valueStr}`
				];
				this.action = 'Make Buy Order';
				break;

			case 'NewTsReq':
				this.details = [
					getOptionInfo(+cuttedData[0], 'Old option: ') || 'unknown option',
					getOptionInfo(+cuttedData[2], 'New option: ') || 'unknown option',
					`Target: ${new cBigNumber(cuttedData[4], {currentDecimals: 18}).valueStr},
					Amount: ${new cBigNumber(cuttedData[5], {currentDecimals: 18}).valueStr},
					Return percent: ${new cBigNumber(cuttedData[6], {currentDecimals: 18}).valueStr},
					Price: ${new cBigNumber(cuttedData[7], {currentDecimals: 18}).valueStr},
					Ref price: ${new cBigNumber(cuttedData[8], {currentDecimals: 18}).valueStr},
					Delta: ${new cBigNumber(cuttedData[9], {currentDecimals: 18}).valueStr},
					Min price: ${new cBigNumber(cuttedData[10], {currentDecimals: 18}).valueStr}`
				];
				this.action = 'New TS Request';
				break;

			case 'ChangeBuyOrder':
				if (+new cBigNumber(cuttedData[3], {currentDecimals: 18}).valueStr === 0){
					this.details = [
						getOptionInfo(+cuttedData[1]) || 'unknown option'
					];
					this.action = 'Cancel Buy Order'
				} else {
					this.details = [
						getOptionInfo(+cuttedData[1]) || 'unknown option',
						`Amount: ${new cBigNumber(cuttedData[3], {currentDecimals: 18}).valueStr},
						Ref price: ${new cBigNumber(cuttedData[4], {currentDecimals: 18}).valueStr},
						Delta: ${new cBigNumber(cuttedData[5], {currentDecimals: 18}).valueStr},
						Order price: ${new cBigNumber(cuttedData[6], {currentDecimals: 18}).valueStr},
						Min price: ${new cBigNumber(cuttedData[7], {currentDecimals: 18}).valueStr}`
					];
					this.action = 'Change Buy Order'
				}
				break;

			case 'ChangeSellOrder':
				if (+new cBigNumber(cuttedData[3], {currentDecimals: 18}).valueStr === 0){
					this.details = [
						getOptionInfo(+cuttedData[1]) || 'unknown option'
					];
					this.action = 'Cancel Sell Order'
				} else {
					this.details = [
						getOptionInfo(+cuttedData[1]) || 'unknown option',
						`Amount: ${new cBigNumber(cuttedData[3], {currentDecimals: 18}).valueStr},
						Ref price: ${new cBigNumber(cuttedData[4], {currentDecimals: 18}).valueStr},
						Delta: ${new cBigNumber(cuttedData[5], {currentDecimals: 18}).valueStr},
						Order price: ${new cBigNumber(cuttedData[6], {currentDecimals: 18}).valueStr},
						Min price: ${new cBigNumber(cuttedData[7], {currentDecimals: 18}).valueStr}`
					];
					this.action = 'Change Sell Order'
				}
				break;

			case 'PushTsReq':
				this.details = [
					getOptionInfo(+cuttedData[0]) || 'unknown option',
					`Option amount: ${new cBigNumber(cuttedData[2], {currentDecimals: 18}).valueStr},
					Borrow amount: ${new cBigNumber(cuttedData[3], {currentDecimals: 18}).valueStr}`
				];
				this.action = 'Push TS Req';
				break;

			case 'UncreateOption':
				this.details = [
					getOptionInfo(+cuttedData[1]) || 'unknown option',
					`Amount: ${new cBigNumber(cuttedData[2], {currentDecimals: 18}).valueStr}`
				];
				this.action = 'Uncreate Option';
				break;

			case 'ChangeBorrow':
				this.details = [
					getOptionInfo(+cuttedData[1]) || 'unknown option',
					`Amount: ${new cBigNumber(cuttedData[2], {currentDecimals: 18}).valueStr}`
				];
				this.action = 'Change Borrow';
				break;

			/*case '':
				this.details = [``]
				break;
			*/

			default:
				this.details = [];
				break;
		}
	}
}